import { ErrorHandler, NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import  { TabsModule } from 'ngx-bootstrap/tabs';
import { CoreEnvironmentService, EasCoreLibModule, EasErrorHandler } from 'eas-core-lib';
import { UserProfileModule } from './modules/user-profile/user-profile.module';

import { Injector} from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { UserProfileElementComponent } from './user-profile-element/user-profile-element.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { coreEnvironment } from 'src/environments/core.environment';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [
      BrowserModule,
      AppRoutingModule,
      TabsModule.forRoot(),
      EasCoreLibModule,
      UserProfileModule,
      UserProfileElementComponent,
      BrowserAnimationsModule], 
    providers: [
        {
            provide: CoreEnvironmentService,
            useValue: coreEnvironment
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
  private injector = inject(Injector);
 
  constructor() {
    const injector = this.injector;

    const el = createCustomElement(UserProfileElementComponent, { injector });
    customElements.define('user-profile-element', el);
  }
  ngDoBootstrap() {}
}
